import React from 'react';

import { useNavigate } from 'react-router';

import Layout from '../components/common/Layout';

const AwaitingSelection = () => {
  const navigate = useNavigate();

  return (
    <Layout>
      <div className="wait-list-page">
        <div className="page-inner">
          <h2>Awaiting Selection Process</h2>
          <div className="main-message">
            <p>
              <b>What it means:</b> You have submitted a complete application and it is currently
              under review for eligibility.
            </p>
            <p>
              <b>What you should do:</b> Check your email for notification about your selection
              decision. You will be either selected, waitlisted, or not selected to move forward in
              the application process.
            </p>
            <p>
              <b>Note:</b> At this stage only Bank Details and Documents can be edited.
            </p>
          </div>
          <div className="button-groups d-flex">
            <button className="primary-btn" onClick={() => navigate('/review')}>
              I want to make some changes
            </button>
            <button className="primary-btn" onClick={() => navigate('/dashboard')}>
              Return to Dashboard
            </button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AwaitingSelection;
